"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NODE_TYPES = exports.isGroup = exports.isQuestion = void 0;
function isQuestion(questionOrGroup) {
    if (!questionOrGroup) {
        return false;
    }
    return questionOrGroup.answers !== undefined;
}
exports.isQuestion = isQuestion;
function isGroup(questionOrGroup) {
    if (!questionOrGroup) {
        return false;
    }
    return questionOrGroup.nodes !== undefined;
}
exports.isGroup = isGroup;
var NODE_TYPES;
(function (NODE_TYPES) {
    NODE_TYPES[NODE_TYPES["UNDEFINED"] = -1] = "UNDEFINED";
    NODE_TYPES[NODE_TYPES["QUESTION_SINGLE"] = 0] = "QUESTION_SINGLE";
    NODE_TYPES[NODE_TYPES["QUESTION_MULTIPLE"] = 1] = "QUESTION_MULTIPLE";
    NODE_TYPES[NODE_TYPES["QUESTION_DESCRIPTION"] = 3] = "QUESTION_DESCRIPTION";
    NODE_TYPES[NODE_TYPES["QUESTION_RATING"] = 8] = "QUESTION_RATING";
    NODE_TYPES[NODE_TYPES["QUESTION_SLIDER"] = 9] = "QUESTION_SLIDER";
    NODE_TYPES[NODE_TYPES["QUESTION_OPEN_ENDED"] = 10] = "QUESTION_OPEN_ENDED";
    NODE_TYPES[NODE_TYPES["QUESTION_NUMERIC_OPEN_ENDED"] = 11] = "QUESTION_NUMERIC_OPEN_ENDED";
    NODE_TYPES[NODE_TYPES["QUESTION_RANKING"] = 12] = "QUESTION_RANKING";
    NODE_TYPES[NODE_TYPES["QUESTION_MATRIX_SINGLE"] = 13] = "QUESTION_MATRIX_SINGLE";
    NODE_TYPES[NODE_TYPES["QUESTION_MATRIX_MULTIPLE"] = 14] = "QUESTION_MATRIX_MULTIPLE";
    NODE_TYPES[NODE_TYPES["QUESTION_NPS"] = 15] = "QUESTION_NPS";
    NODE_TYPES[NODE_TYPES["QUESTION_MATRIX_SINGLE_BIPOLAR"] = 18] = "QUESTION_MATRIX_SINGLE_BIPOLAR";
    NODE_TYPES[NODE_TYPES["QUESTION_DRILLDOWN"] = 19] = "QUESTION_DRILLDOWN";
    NODE_TYPES[NODE_TYPES["QUESTION_MATRIX_OPEN_ENDED"] = 20] = "QUESTION_MATRIX_OPEN_ENDED";
    NODE_TYPES[NODE_TYPES["QUESTION_MATRIX_NUMERIC_OPEN_ENDED"] = 21] = "QUESTION_MATRIX_NUMERIC_OPEN_ENDED";
    NODE_TYPES[NODE_TYPES["QUESTION_MATRIX_CONSTANT_SUM"] = 22] = "QUESTION_MATRIX_CONSTANT_SUM";
    NODE_TYPES["GROUP_BASIC"] = "BASIC";
    NODE_TYPES["GROUP_AB"] = "AB";
    NODE_TYPES["GROUP_CONJOINT"] = "CONJOINT";
    NODE_TYPES["GROUP_VAN_WESTENDORP"] = "VAN_WESTENDORP";
    NODE_TYPES["GROUP_MAXDIFF"] = "MAXDIFF";
})(NODE_TYPES = exports.NODE_TYPES || (exports.NODE_TYPES = {}));
